import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import "../../css/home3.css";



function HomeSection3() {
  const navigate = useNavigate();

  const [activeIndex, setActiveIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % 3); // Assuming there are 3 slides
    }, 15000); // Change slide every 5 seconds

    return () => clearInterval(interval); // Cleanup on unmount

  }, []);

  return (
    <section id="section4">
      <div className="row">
        <div className="col-12 text-center">
          <p className="h1 section3-title mt-5">Sobre Nosotros</p>
        </div>
      </div>
      <div className="row">
        <div id="carouselExampleIndicators" className="carousel slide">
          <div className="carousel-indicators">
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className={activeIndex === 0 ? "active" : ""} aria-current={activeIndex === 0 ? "true" : "false"}  aria-label="Slide 1"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" className={activeIndex === 1 ? "active" : ""} aria-label="Slide 2"></button>
            <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" className={activeIndex === 2 ? "active" : ""}aria-label="Slide 3"></button>
          </div>
          <div className="carousel-inner">
            {/* First Slide */}
            <div className={`carousel-item ${activeIndex === 0 ? "active" : ""}`}>
              <div className="container">
                <div className="row align-items-center justify-content-center">
                  <div className="col-lg-4 col-md-5 col-10 mb-4 mb-md-0">
                    <img src={require(`../../img/pfp.PNG`)} alt="profile" className="pfp" />
                  </div>
                  <div className="col-lg-7 col-md-7 col-12">
                    <div className="text-justify px-3 px-md-0">
                      <p className="h3 carousel-title">
                        ¿Quienes somos?
                      </p>
                      <p>
                        Somos una consultora especializada en ayudar a pequeñas y medianas empresas a dar el salto hacia
                        la internacionalización. En voilà, entendemos los desafíos de exportar y convertimos cada barrera
                        en una oportunidad.
                      </p>
                    </div>
                    <div className="text-center text-md-start mt-4">
                      <button className="btn btn-carousel" onClick={() => navigate('/services')}>Ver todos los Servicios</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Second Slide */}
            <div className={`carousel-item ${activeIndex === 1 ? "active" : ""}`}>
              <div className="container">
                <div className="row align-items-center justify-content-center">
                  <div className="col-lg-4 col-md-5 col-10 mb-4 mb-md-0">
                    <img src={require(`../../img/meeting.png`)} alt="profile" className="pfp" />
                  </div>
                  <div className="col-lg-7 col-md-7 col-12">
                    <div className="text-justify px-3 px-md-0 mission-vision-content">
                      <p className="h3 carousel-title">
                        Nuestra Misión
                      </p>
                      <p className="mission-text">
                        Conectar a las MYPES y PYMES con el mundo, mediante asesoría personalizada que combina estrategia,
                        gestión práctica y acompañamiento continuo.
                      </p>
                      <p className="h3 carousel-title mt-3 mt-md-4">
                        Nuestra Visión
                      </p>
                      <p className="vision-text">
                        Ser la consultora de referencia para empresas que quieren competir globalmente,
                        aportando soluciones ágiles, accesibles y sostenibles.
                      </p>
                    </div>
                    <div className="text-center text-md-start mt-3 mt-md-4 px-3 px-md-0">
                      <button className="btn btn-carousel" onClick={() => navigate('/services')}>Ver todos los Servicios</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Third Slide - Fixed for Responsiveness */}
            <div className={`carousel-item ${activeIndex === 2 ? "active" : ""}`}>
              <div className="container">
                <div className="row align-items-center justify-content-center">
                  <div className="col-lg-4 col-md-5 col-10 mb-4 mb-md-0">
                    <img src={require(`../../img/diferencia.png`)} alt="profile" className="pfp" />
                  </div>
                  <div className="col-lg-7 col-md-7 col-12">
                    <div className="text-justify px-3 px-md-0">
                      <p className="h3 text-start mb-3">
                        Lo que nos diferencia
                      </p>
                      {/* Simplified structure with a single paragraph and list */}
                      <div className="diferencias-list mb-3">
                        <p className="mb-2 text-start">🕒 Respuestas rápidas y cercanas.</p>
                        <p className="mb-2 text-start">💡 Metodología de enseñanza práctica que empodera a las empresas.</p>
                        <p className="mb-2 text-start">🔀 Enfoque interdisciplinario: conectamos logística, marketing y finanzas.</p>
                        <p className="mb-2 text-start">🎯 Acompañamiento integral en cada etapa de exportación.</p>
                      </div>
                    </div>
                    <div className="text-center text-md-start px-3 px-md-0">
                      <button className="btn btn-carousel" onClick={() => navigate('/services')}>Ver todos los Servicios</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </section>
  );
}

export default HomeSection3;